import { createContext } from "react";
import { Profile } from "../types";
import { IPLocationState } from "../reducers/ipLocation";

const data = { language: "", userId: "", profile: null as Profile, location: null as IPLocationState };
export type UserContextData = typeof data;

const UserContext = createContext(data);

export default UserContext;
